import { Position } from '@models/position';
import { PositionCreationMode } from '@core/models';

/**
 * classe per analizzare le position ed identificare quella aperta e la modalità di creazione consentita
 */
export abstract class PositionInspector {
  protected positions: Position[];

  constructor(positions: Position[]) {
    this.positions = positions;
  }

  protected find(predicate: (position: Position) => boolean): Position {
    return this.positions.find(x => predicate(x));
  }

  abstract detectOpenPosition(): Position;

  abstract detectCreationMode(): PositionCreationMode;
}
